<div
    [formGroup]="form"
    [ngSwitch]="step"
    appVenueColour
    [primaryColour]="primaryColour"
>
@if(!isErroneouslyUsingOldWidget) {
    @if (venueNotInService) {
        <div class="container col-sm-10 col-md-8 col-lg-6 col-xl-4 my-2">
            <app-venue-not-in-service></app-venue-not-in-service>
        </div>
    } @else {
        <app-spinner-overlay
            [showSpinner]="isLoadingAvailability"
        >
        </app-spinner-overlay>
        <ng-container
            *ngIf="availability | async as availability"
        >
            <app-booking-slot
                *ngSwitchCase="formStep.BookingSlot"
                [availability]="availability"
            >
            </app-booking-slot>
            <app-order-selection
                [partySize]="form.get('BookingSlot.partySize')!.value"
                *ngSwitchCase="formStep.Order"
                [availability]="availability"
                [selectedReasonId]="form.get('BookingSlot.selectedReasonId')!.value"
                (orderConfirmed)="step = formStep.BookingDetails"
            ></app-order-selection>
            <app-booking-details-form
                *ngSwitchCase="formStep.BookingDetails"
                (backSelected)="goBackFromBookingDetails()"
                (nextSelected)="goNextFromBookingDetails()"
                (bookSelected)="bookButtonSelected()"
            >
            </app-booking-details-form>
        </ng-container>
        <ng-container
            *ngSwitchCase="formStep.PaymentDetails"
        >
            <div class="container col-sm-10 col-md-8 col-lg-6 col-xl-4 my-2">
                <app-payment-details-form
                    [showTitle]="true"
                    [showBackButton]="true"
                    (backSelected)="goBackFromPaymentDetails()"
                    (bookSelected)="bookButtonSelected()"
                >
                </app-payment-details-form>
            </div>
        </ng-container>
        <ng-container
            *ngSwitchCase="formStep.Deposit"
        >
            <div class="container col-sm-10 col-md-8 col-lg-6 col-xl-4 my-2">
                <app-deposit-form
                    [showTitle]="true"
                    [showBackButton]="true"
                    (backSelected)="goBackFromDeposit()"
                    (bookSelected)="bookButtonSelected()"
                >
                </app-deposit-form>
            </div>
        </ng-container>
        <ng-container
            *ngSwitchCase="formStep.Confirmation"
        >
            <app-confirmation
                *ngIf="bookingDetails !== null"
                [details]="bookingDetails"
                (bookAgainSelected)="bookAgainSelected()"
            >
            </app-confirmation>
        </ng-container>
    }
} @else if (landingPageUrl) {
    <div class="p-4">
        <a
            class="btn btn-lg btn-primary w-100 fw-semibold hstack justify-content-center gap-2"
            appVenueColour
            [primaryColour]="primaryColour"
            [href]="landingPageUrl"
            target="_blank"
        >
            Book a Table
            <i class="bi bi-box-arrow-up-right"></i>
        </a>
    </div>
}
</div>
